var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _mask, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 24,
    viewBox: "0 0 121 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2687 0L4.67492 23.9218L4.65168 23.9899L12.224 18.6042L12.2398 18.5923L19.925 24L17.2253 14.9461L17.2298 14.9288L24.7088 8.95979L24.6434 8.96383L15.3436 8.96443L12.2687 0ZM12.6368 6.37806L11.4538 6.01068L11.459 6.00463L11.8867 4.66772L11.9036 4.678L13.0529 5.03087L12.648 6.3829L12.6368 6.37806ZM10.5765 8.86951L10.57 8.85339L10.9605 7.52957L12.1669 7.92335L12.1575 7.94633L11.752 9.20404L11.7477 9.22117L10.5765 8.86951ZM9.63381 11.7265L9.63834 11.71L10.0629 10.4172L11.2309 10.8025L11.227 10.8249L10.828 12.0991L10.8233 12.1106L9.63381 11.7265ZM8.72616 14.6261L8.70942 14.616L9.14542 13.3285L9.14975 13.3119L10.3229 13.6962L10.3134 13.7192L9.90439 15.0049L8.72616 14.6261ZM7.82402 17.5256L7.80728 17.5212L8.23679 16.2115L8.25313 16.2155L9.36618 16.5879L8.9995 17.8545L8.98945 17.8716L7.82402 17.5256ZM8.05935 20.7559L6.87423 20.3554L7.29467 19.08L7.30432 19.0566L8.48413 19.4637L8.47586 19.5084L8.08161 20.7653L8.05935 20.7559ZM8.08811 8.96907L0.0539588 8.97309L0 8.9733L6.61881 14.35L6.62413 14.3316L8.32166 8.96886L8.08811 8.96907Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3028 8.74866L41.4235 9.6402L37.7155 14.5131L41.5614 20.1912L39.2851 21.0286L35.2748 14.6995H35.2439V20.7555L33.0339 20.8919V9.02152L35.2439 8.74866V14.1898H35.2748L39.3028 8.74866Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6863 20.8919V9.02166L45.8915 8.7486V20.7554L43.6863 20.8919Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3865 21.0285V8.7486H49.4351L56.2865 15.8463V9.02166L58.4915 8.7486V21.0285H58.4474L51.5915 14.0173V20.7556L49.3865 21.0285Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8569 20.7555V9.02148H68.0234L68.3881 11.1963H64.0622V13.5395H67.539V15.7097H64.0622V18.585H68.9259L68.2235 20.7555H61.8569Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7101 14.4132H74.2436C75.564 14.4132 76.2842 13.9173 76.2842 12.8024C76.2842 11.6922 75.564 11.1965 74.2436 11.1965H73.7101V14.4132ZM73.7101 20.7556L71.5049 20.8918V9.02161H74.7767C77.4047 9.02161 78.4894 11.1965 78.4894 12.716C78.4894 15.0956 76.8842 16.5832 74.5945 16.5832C74.2922 16.5832 74.0124 16.5649 73.7101 16.533V20.7556Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.4966 18.7218C88.5374 18.7218 90.24 16.9746 90.24 14.8906C90.24 12.8024 88.5374 11.0596 86.4966 11.0596C84.4602 11.0596 82.753 12.8024 82.753 14.8906C82.753 16.9746 84.4602 18.7218 86.4966 18.7218ZM86.4966 8.74872C89.8042 8.74872 92.5475 11.4876 92.5475 14.8906C92.5475 18.2939 89.8042 21.0284 86.4966 21.0284C83.1886 21.0284 80.4456 18.2939 80.4456 14.8906C80.4456 11.4876 83.1886 8.74872 86.4966 8.74872Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.375 20.7555V9.02152L97.5802 8.74866V18.5851H101.759L101.208 20.7555H95.375Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.151 20.8919V9.02172L106.357 8.74866V20.7555L104.151 20.8919Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.704 17.5935C111.274 18.2436 111.674 18.8579 112.91 18.8579C113.697 18.8579 114.381 18.2259 114.381 17.5071C114.381 15.1821 109.384 16.497 109.384 12.3428C109.384 10.0996 111.02 8.7486 113.297 8.7486C114.43 8.7486 115.818 9.39952 116.502 10.3412L115.133 11.9837C114.599 11.4011 113.781 10.9233 113.159 10.9233C112.39 10.9233 111.692 11.2648 111.692 12.3428C111.692 14.3449 116.689 12.9071 116.689 17.5248C116.689 19.6634 114.951 21.0285 112.794 21.0285C111.358 21.0285 110.153 20.4141 109.184 19.1993L110.704 17.5935Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 6,
    width: 4,
    height: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.004 6.05536H120.535V9.55403H117.004V6.05536Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.836 7.62947C119.014 7.62947 119.143 7.59279 119.143 7.38361C119.143 7.1835 118.916 7.16979 118.765 7.16979H118.485V7.62947H118.836ZM118.485 8.76224H118.076V6.84675H118.779C119.263 6.84675 119.547 6.98358 119.547 7.42472C119.547 7.77497 119.343 7.9116 119.032 7.92934L119.516 8.76224H119.103L118.667 7.95272H118.485V8.76224ZM118.769 6.46466C118.081 6.46466 117.529 7.01059 117.529 7.80661C117.529 8.5984 118.081 9.14453 118.769 9.14453C119.445 9.14453 120.005 8.5984 120.005 7.80661C120.005 7.01059 119.445 6.46466 118.769 6.46466ZM117.004 7.80661C117.004 6.71031 117.849 6.05536 118.769 6.05536C119.69 6.05536 120.535 6.71031 120.535 7.80661C120.535 8.90311 119.69 9.55403 118.769 9.55403C117.849 9.55403 117.004 8.90311 117.004 7.80661Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.32dd38e53226ddd3ea594cafee9e45e1.svg";
export { ForwardRef as ReactComponent };